import { Loader2 } from "lucide-react";

export function PageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-cream">
      <Loader2 className="animate-spin text-ink-soft" />
    </div>
  );
}
